let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5g5GD"), load("5HsIb"), load("3L8bY"), load("f4DD6")]).then(() => parcelRequire('6JHmj'));